<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="900"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <span class="ml-4 subtitle-2 text-uppercase">{{ productName }}</span>
                            </v-col>
                            <v-col cols="12" class="pt-0">
                                <v-simple-table class="wost-table-detail" height="70vh">
                                    <thead class="debt-header-payment">
                                        <tr>
                                            <th class="text-left">Detalle</th>
                                            <th class="text-left">Tipo</th>
                                            <th class="text-left">Cantidad</th>
                                            <th class="text-left">Total</th>
                                            <th class="text-left">Hora</th>
                                            <th class="text-left">Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="product in kardex" :key="product.id">
                                            <td>{{ product.description }}</td>
                                            <td>
                                                <span :class="'kardex-type kardex-' + product.type.toLowerCase()">{{ product.type }}</span>
                                            </td>
                                            <td>{{ product.quantity }}</td>
                                            <td>{{ product.stock}}</td>
                                            <td>{{ product.register_date | moment("h:mm a") }}</td>
                                            <td>{{ product.register_date | moment("DD/MM/YYYY") }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </template>
            </v-card>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'Kardex',
    data() {
        return {
            productName: '',
            titleForm: '',
            drawer: false
        }
    },
    computed: {
        ...mapState('storehouses', [
            'kardex'
        ]),
    },
    methods: {
        showForm(title, productName) {
            this.titleForm = title
            this.productName = productName
            this.drawer = !this.drawer
        },
    }
}
</script>

<style>
.kardex-type{
    display: block;
    color: #ffffff;
    font-size: 12px !important;
    text-align: center;
    border-radius: 5px;
    width: 110px;
}

.kardex-ingreso {
    background-color: #388E3C;
}

.kardex-salida {
    background-color: #D32F2F;
}

.kardex-merma {
    background-color: #FFA000;
}
</style>